var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-render",style:({ minHeight: _vm.isEditMode && 'inherit' })},[(_vm.isAlive)?_c('RootMatcher',{ref:"rootMatcher",attrs:{"renderData":_vm.renderData},on:{"openEditor":_vm.openEditor,"openChildEditor":_vm.openChildEditor,"changeChildrenOrder":_vm.changeChildrenOrder}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }